module.exports = __webpack_public_path__ + "media/images/close-9bd63bec.png";